module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLight.117eff1f.eot";